import './Preloader.css';

const Preloader = () => (
	<div className="preloader">
		<div className="preloader-loader" />
	</div>
);

export default Preloader;
